
const nameInitials = (item) => {
  const split = item.split(" ");
  const initials = `${split[0].substr(0, 1)}${split[1].substr(0, 1)}`;
  return initials;
};
export default nameInitials;
